module.exports = __webpack_public_path__ + "static/media/second-logo-ru.9484276f.svg";